import { HttpHeaders } from '@angular/common/http';

export class Config {
    HEADER: HttpHeaders;
    API_URL:string;
}

export const APP_CONFIG: Config = {
    HEADER: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }),
    API_URL:'/api'
};